import React, { lazy } from 'react';
import { Navigate, Route } from 'react-router-dom';
import AccountantDetailsRoutes from './AccountantDetailsRoutes';
import { suspense } from './utils';

const ViewAccountants = lazy(
  () => import('admin/features/accountants/viewAccountants'),
);

const NewAccountantsRequests = lazy(
  () =>
    import('admin/features/accountants/viewAccountants/NewAccountantsRequests'),
);

const CurrentAccountants = lazy(
  () => import('admin/features/accountants/viewAccountants/CurrentAccountants'),
);
export default function AccountantsRoutes() {
  return (
    <>
      <Route path="viewAccountants" element={suspense(<ViewAccountants />)}>
        <Route path="current" element={<CurrentAccountants />} />
        <Route path="new" element={<NewAccountantsRequests />} />
        <Route path="" element={<Navigate replace to="current" />} />
      </Route>
      {AccountantDetailsRoutes()}
    </>
  );
}
